import React from 'react'
import { AiOutlineMinusCircle, AiOutlinePlusCircle } from "react-icons/ai"
import * as styles from './incrementDecrementButtons.module.scss'

export default ({
    value,
    id,
    name,
    incrementFunc,
    decrementFunc,
    customValueFunc,
    beforeText,
    afterText,
    disabled,
    xl,
}: {
    value: number,
    id: string,
    name: string,
    incrementFunc: () => void,
    decrementFunc: () => void,
    customValueFunc: (e: React.ChangeEvent<HTMLInputElement>) => void,
    beforeText?: string,
    afterText?: string,
    disabled?: boolean,
    xl?: boolean
}) => ( 
    <div className={`
        ${styles.totalSelector}
        ${disabled ? styles.disabled : ''}
    `}>
        {beforeText && (
            <div className={`
                ${styles.incrementDecrementSupplimentaryText}
                ${styles.decrementText}
            `}>
                {beforeText}
            </div>
        )}
        <button
            type="button"
            className={styles.adjustAmountButton}
            disabled={disabled || value <= 1}
            onClick={decrementFunc}
            title="Decrease Quantity"
        >
            <AiOutlineMinusCircle size={25} />
        </button>
        <input
            type="number"
            id={id}
            name={name}
            min="1"
            max="10000"
            className={`
                ${styles.quantityInput}
                ${xl ? styles.xl : ''}
            `}
            value={value}
            onChange={customValueFunc}
        ></input>
        <button
            type="button"
            className={styles.adjustAmountButton}
            onClick={incrementFunc}
            disabled={disabled}
            title="Increase Quantity"
        >
            <AiOutlinePlusCircle size={25} />
        </button>
        {afterText && (
            <div className={`
                ${styles.incrementDecrementSupplimentaryText}
                ${styles.incrementText}
            `}>
                {afterText}
            </div>
        )}
    </div>
)